import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUpDown16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCaretUpDown16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.18 9.857a.5.5 0 1 0-.706-.707l-2.475 2.475L5.525 9.15a.5.5 0 0 0-.707.707l2.827 2.827.354.354.353-.354zM4.819 6.138a.5.5 0 1 0 .707.707L8 4.37l2.474 2.474a.5.5 0 1 0 .707-.707L8.353 3.31 8 2.956l-.354.354z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUpDown16);
